import { render } from "./InfoPage.vue?vue&type=template&id=0e330133&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=0e330133&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e330133"]])

export default __exports__